import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import styles from "./Skills.module.css";
import HashLoader from "react-spinners/HashLoader";
import "animate.css";
import { motion } from "framer-motion";
// firebase
import { getSkills } from "../../Firebase/FirebaseFetch";

function Skills() {
  const [skillsData, setSkillsData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [screen, setScreen] = useState("");
  useEffect(() => {
    getSkills()
      .then((res) => {
        setSkillsData(res);

        setIsLoading(false);
        return res;
      })
      .catch((error) => console.error(error));
  }, []);
  useEffect(() => {
    const renderSkill = skillsData.map((item, index) => {
      return (
        <Col key={index} lg={3} md={4} sm={2} className={styles.card}>
          <motion.div
            initial={{ scale: 0.2, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{
              duration: 0.6,
              delay: 1,
            }}
            className={`text-center`}
          >
            <motion.div
              whileHover={{ scale: 1.1 }}
              transition={{ type: "spring", stiffness: 400, damping: 10 }}
            >
              <h5 className={styles.title}>
                {item._document.data.value.mapValue.fields.name.stringValue.toUpperCase()}
              </h5>
              <img
                className={styles.icon}
                src={item._document.data.value.mapValue.fields.url.stringValue}
                alt={item._document.data.value.mapValue.fields.name.stringValue}
              />
            </motion.div>
          </motion.div>
        </Col>
      );
    });
    setScreen(renderSkill);
  }, [skillsData]);
  return (
    <Container id="skills" className={styles.skills}>
      <div>
        {isLoading ? (
          <div className={styles.loader}>
            <HashLoader color="#ffffff" />
          </div>
        ) : (
          <>
            <Row>
              <h3
                className={`${styles.heading} text-center text-md-start animate__animated animate__fadeInLeft`}
              >
                My <span className={styles.important}>Skills</span>
              </h3>
            </Row>
            <Row className={`${styles.cardContainer} `}>{screen}</Row>
          </>
        )}
      </div>
    </Container>
  );
}

export default Skills;
